/*
 * @fileOverView Search Filter Grants component definition
 *
 * Built to work with the Search Pill Suggest component.
 */

import Vue from 'vue';
import Search from 'components/modules/utility/search/search.mixin';
import { KeyCodes } from 'utils/Constants';
import { mapGetters } from 'vuex'

/**
 * [Search Filter Grants Vue]
 * @type {class}
 */
Vue.component('search-filter-grants-vue', {
  mixins: [Search],

  props: ['category'],

  computed: {
    ...mapGetters(['filterGrantSuggestions/filter']),
    filterSearch() {
      const suggestions = this['filterGrantSuggestions/filter'](this.category, this.search);

      if (suggestions) {
        return suggestions.map(item => {
          return {
            "term": item
          }
        });
      }
    }
  },

  mounted() {
    if (!this.$store.state['filterGrantSuggestions'].loaded) {
      this.$store.dispatch('filterGrantSuggestions/fetch');
    }
  },

  methods: {
    /**
     * Handles the event when clicking outside of the search area.
     */
    handleClickOutside(e) {
      if (this.isActive && !this.$el.contains(e.target) && this.$el !== e.target) {
        this.isActive = false;
      }
    },

    /**
     * Handles setting the form back to inactive when the esc key is pressed
     */
    handleResetKeydown(e) {
      if (e.keyCode === KeyCodes.ESCAPE) {
        this.isActive = false;
      }
    },

    /**
     * Handles the submission of the search form element.
     */
    handleSubmit: function (e) {
      this.isActive = false;
      this.submit();

      if (e) {
        e.preventDefault();
      }
    },

    /**
     * Resets the element to the default value.
     *
     * Exists to be used by parent elements, such as filters.
     */
    reset() {
      this.set('');
    },

    /**
     * Set the element to a specific value.
     *
     * Exists to be used by parent elements, such as filters.
     *
     * @param {String} value
     *   The value to set the element to.
     */
    set(value) {
      this.search = value;
      this.submit();
    },

    /**
     * Emits an event for parents that need to react, such as filters.
     */
    submit() {
      this.$emit('searchpill-submit', this.search, this.$el);
    },

    /**
     * Submit handler for this component.
     */
    searchPillSubmitted() {
      submit()
    }
  }
});
